// Fired after any task/order mutation so every open view (Messages → Tasks,
// Orders & followups, audio panel, Compliance tab) reloads.
export const WORK_ITEMS_CHANGED = "notesai:work-items-changed";

export function emitWorkItemsChanged(detail = {}) {
  window.dispatchEvent(new CustomEvent(WORK_ITEMS_CHANGED, { detail }));
}

export function onWorkItemsChanged(cb) {
  window.addEventListener(WORK_ITEMS_CHANGED, cb);
  return () => window.removeEventListener(WORK_ITEMS_CHANGED, cb);
}
